import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getTranslations } from "../../../../services/languageUtils";

import "react-rangeslider/lib/index.css";
/*
  A aba de chaves passou a falar com o endpoint NOVO, pela Gowd. O serviço da Celcoin
  continua existindo para os fluxos antigos desta tela, mas as chaves PIX da conta são as
  do provedor que mantém a conta — listar de um e criar no outro mostraria uma lista que
  não corresponde ao que existe.
*/
import KeysManagementService from "../../../../services/Gowd/keysManagementService";
import UtilService from "../../../../services/Celcoin/utilService";
import CashOutService from "../../../../services/Celcoin/dinamicCashOutService";
import AccountManagerService from "../../../../services/Celcoin/accountManagerService";

import Modal from "./Components/Modals/modal";
import ModalInfo from "./Components/Modals/modalInfo";
import ModalKeysInfo from "./Components/Modals/modalKeysInfo";

import TransferTypePix from "./Components/Transfer/TransferTypePix";
import TransferTypeCopyPaste from "./Components/Transfer/TransferTypeCopyPaste";
import TransferTypeCopyPasteMutual from "./Components/Transfer/TransferTypeCopyPasteMutual";
import TransferTypeBatch from "./Components/Transfer/TransferTypeBatch";
import TransferTypeQRCode from "./Components/Transfer/TransferTypeQRCode";
import TransferTypePixLimits from "./Components/Transfer/TransferTypePixLimits";
import TransferTypePixMutual from "./Components/Transfer/TransferTypePixMutual";
import TransferTypePixKey from "./Components/Transfer/TransferTypePixKey";
import TransferOrderResume from "./Components/Transfer/TransferOrderResume";
import TransferTypeBankAccount from "./Components/Transfer/TransferTypeBankAccount";
import TransferComplete from "./Components/Transfer/TransferComplete";
import { isMutual } from "../../../../utils/isMutual";
import { isMtBank } from "../../../../utils/isMtBank";
import { isVoluti } from "../../../../utils/isVoluti";

class Item extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 0,
      contacts: [],
      value: 10,
      recipientValue: "",
      codeRead: "",
      openQr: false,
      isModalOpen: false,
      selectedOption: null,
      listKeys: [],
      creditPartyTaxId: "",
      accountSearchPix: "",
      keySearchPix: "",
      currentBalance: 0,
      currentPayment: {
        amount: 0,
        clientCode: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        transactionIdentification: "",
        endtoEndId: "",
        initiationType: "DICT",
        paymentType: "IMMEDIATE",
        urgency: "HIGH",
        transactionType: "TRANSFER",
        debitParty: {
          account: "",
          email: "",
        },
        creditParty: {
          bank: "",
          key: "",
          name: "",
          accountType: "",
        },
        remittanceInformation: "",
      },
      resultPayment: {
        creditParty: {
          name: "",
          key: "",
          bank: "",
          branch: "",
          account: "",
        },
        amount: 0,
        id: "",
      },
      processingQrCode: false,
      isModalInfoOpen: false,
      isModalKeysOpen: false,
      valueDayCnpj: 3000,
      valueNightPayments: 1000,
      valueNightCpf: 1000,
      docSearchPix: "",
      endToEnd: "",
      conciliationId: "",
      nameSearchPix: "",
      valueNightCnpj: 1000,
      valueDayPayments: 3000,
      valueDayCpf: 3000,
      translations: {},
      loadingTranfer: false,
      resSearchExternalKey: {
        keyType: "",
        key: "",
        account: {
          participant: "",
          branch: "",
          account: "",
        },
        owner: {
          documentNumber: "",
          name: "",
        },
      },
      pixKeyType: "CPF",
      show2FAModal: false,
      twoFactorCode: "",
      loading2FA: false,
      transferPending: false,
      emvPayment: null,
    };
    this.updateBalance = this.updateBalance.bind(this);
    this.updateKeys = this.updateKeys.bind(this);
    this.checkCameraAvailability = this.checkCameraAvailability.bind(this);
    this.handleResult = this.handleResult.bind(this);
    this.proceed = this.proceed.bind(this);
    this.back = this.back.bind(this);
    this.deleteKey = this.deleteKey.bind(this);
    this.showExternalKey = this.showExternalKey.bind(this);
    this.searchKeyDict = this.searchKeyDict.bind(this);
    this.sendPayment = this.sendPayment.bind(this);
    this.updateValueTransfer = this.updateValueTransfer.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.QRScanner = this.QRScanner.bind(this);
    this.setOpenQr = this.setOpenQr.bind(this);
    this.clearCurrentPayment = this.clearCurrentPayment.bind(this);
    this.updateDescription = this.updateDescription.bind(this);
    this.decodeQrCode = this.decodeQrCode.bind(this);
    this.resetPixSettings = this.resetPixSettings.bind(this);
    this.handlePixKeyClick = this.handlePixKeyClick.bind(this);
    this.removeMask = this.removeMask.bind(this);
    this.handleChangeKeyPix = this.handleChangeKeyPix.bind(this);
    this.handleKeyTypeChange = this.handleKeyTypeChange.bind(this);
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  getContacts() {
    const that = this;
    AccountManagerService.indexContacts()
      .then((res) => {
        that.setState({ contacts: res.data });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  clearCurrentPayment() {
    this.setState({
      currentPayment: {
        amount: 0,
        clientCode: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        transactionIdentification: "",
        endtoEndId: "",
        initiationType: "DICT",
        paymentType: "IMMEDIATE",
        creditPartyTaxId: "",
        urgency: "HIGH",
        transactionType: "TRANSFER",
        debitParty: {
          account: "",
        },
        creditParty: {
          bank: "",
          key: "",
          name: "",
          accountType: "",
        },
        remittanceInformation: "",
      },
      resSearchExternalKey: {
        keyType: "",
        key: "",
        account: {
          participant: "",
          branch: "",
          account: "",
        },
        owner: {
          documentNumber: "",
          name: "",
        },
      },
    });
  }

  setOpenQr() {
    this.setState({ openQr: true });
  }

  handleButtonClick = () => {
    this.setState({ isModalOpen: true });
  };

  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  handleCloseModalInfo = () => {
    this.setState({ isModalInfoOpen: false });
  };

  handleCloseModalKeys = () => {
    this.setState({ isModalKeysOpen: false });
  };

  handleSelectOption = (option) => {
    this.setState({ selectedOption: option });
  };

  componentDidMount() {
    this.loadTranslations();
    this.updateKeys();
    this.updateBalance();
    // Contatos desativados temporariamente (endpoint indexcontacts indisponível)
  }

  updateBalance() {
    let that = this;
    AccountManagerService.showBalance()
      .then((res) => {
        that.setState({ currentBalance: res.data.body.amount });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  updateKeys() {
    let that = this;
    KeysManagementService.index()
      .then((res) => {
        /*
          ── A lista vem DENTRO da resposta ──

          O endpoint devolve `{ accountId, keys: [...], totalKeys }`, e isto guardava o objeto
          inteiro em `listKeys`. A aba faz `Array.isArray(listKeys)` antes de renderizar, então
          um objeto virava lista vazia e a tela dizia "Nenhuma chave Pix cadastrada" com a
          conta tendo chave — sem erro em lugar nenhum, porque tecnicamente nada falhou.

          Os dois formatos são aceitos porque a resposta pode vir embrulhada em `data` pelo
          envelope da API, e depender de um só faria a lista sumir de novo no dia em que o
          outro chegasse.
        */
        const payload = res?.data?.data ?? res?.data;
        const keys = payload?.keys ?? payload?.Keys ?? (Array.isArray(payload) ? payload : []);

        that.setState({ listKeys: Array.isArray(keys) ? keys : [] });
      })
      .catch((err) => {
        console.error(err);
        // Falha deixa a lista VAZIA, e não o objeto anterior: mostrar chaves que podem não
        // existir mais é pior que mostrar nenhuma.
        that.setState({ listKeys: [] });
      });
  }

  checkCameraAvailability = () => {
    let that = this;
    navigator.mediaDevices
      .getUserMedia({ video: true })
      .then((stream) => {
        stream.getTracks().forEach((track) => track.stop());
      })
      .catch((err) => {
        console.error("Erro ao acessar a câmera: ", err);
        that.setState({ openQr: false });
      });
  };

  handleResult = (result, error) => {
    let that = this;
    if (!!result && !that.state.processingQrCode) {
      that.setState({ openQr: false });
      that.decodeQrCode(result?.text);
    }
  };

  decodeQrCode(emv) {
    let that = this;
    UtilService.decodeQrCode({ emv: emv })
      .then((res) => {
        let currentPayment = that.state.currentPayment;
        currentPayment.transactionIdentification =
          res.data.transactionIdentification;
        that.updateValueTransfer(res.data.transactionAmount);
        that.setState(
          {
            keySearchPix: res.data.merchantAccountInformation.key,
            currentPayment: currentPayment,
          },
          () => {
            that.showExternalKey(true);
          },
        );
      })
      .catch((err) => {
        console.error(err);
      });
  }

  QRScanner() {
    return (
      <span>
        {this.state.openQr && (
          <div className="modal-overlay">
            <div className="modal">
              <button
                className="close-button"
                onClick={() => this.setState({ openQr: false })}
              >
                X
              </button>
              <div className="modal-content">
                {
                  // <QrReader
                  //   onResult={this.handleResult}
                  //   style={{ width: '100%' }}
                  // />
                }
              </div>
            </div>
          </div>
        )}
      </span>
    );
  }

  proceed(value) {
    let that = this;
    if (value === 1 && that.state.currentPayment.endtoEndId === "")
      return that.toastMessage("error", this.state.translations.invalidKey);

    that.props.onChangeValue({ target: { name: "step", value: value } });
  }

  back(value) {
    let that = this;
    that.props.onChangeValue({ target: { name: "step", value: value } });
    if (value === 0) {
      that.clearCurrentPayment();
    }
  }


  deleteKey(item) {
    let that = this;

    if (!item?.keyId && !item?.id) {
      console.error("Não foi encontrado keyId para excluir a chave");
      return;
    }
    KeysManagementService.destroy({
      keyId: item.keyId || item.id,
    })
      .then((res) => {
        that.updateKeys();
      })
      .catch((err) => {
        console.error(err);
      });
  }


  resetPixSettings() {
    this.setState({
      valueDayCnpj: 3000,
      valueNightPayments: 1000,
      valueNightCpf: 1000,
      valueNightCnpj: 1000,
      valueDayPayments: 3000,
      valueDayCpf: 3000,
    });
  }

  savePixSettings() {}

  savePixLimitSettings() {
    toast(this.state.translations.newLimitRequested, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      type: "success",
      theme: "light",
    });
  }

  toastMessage(type, message) {
    switch (type) {
      case "success":
        return toast(message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "success",
          theme: "light",
        });
      default:
        return toast(message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "error",
          theme: "light",
        });
    }
  }

  handlePixKeyClick(key, contact) {
    const that = this;
    that.setState(
      {
        keySearchPix: key.pixKey,
        accountSearchPix: contact.accountNumber,
        pixKeyType: key.pixKeyType,
      },
      () => {
        that.showExternalKey(true);
      },
    );
  }

  verify2FAForTransfer = async () => {
    if (this.state.twoFactorCode.length !== 6) {
      return this.toastMessage(
        "error",
        this.state.translations.invalidCode || "Código deve ter 6 dígitos",
      );
    }

    const code = this.state.twoFactorCode;

    this.setState({ loading2FA: true, loadingTranfer: true });

    this.setState(
      {
        show2FAModal: false,
        loading2FA: false,
        twoFactorCode: "",
      },
      () => this.confirmTransfer(code),
    );
  };

  cancel2FA = () => {
    this.setState({
      show2FAModal: false,
      twoFactorCode: "",
      loading2FA: false,
      transferPending: false,
      loadingTranfer: false,
    });
  };

  handleTwoFactorCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").substring(0, 6);
    this.setState({ twoFactorCode: value });
  };

  handleEnter2FA = (e) => {
    if (e.key === "Enter" && this.state.twoFactorCode.length === 6) {
      this.verify2FAForTransfer();
    }
  };

  showExternalKey(showAlert) {
    let that = this;
    let keySearchPix = that.state.keySearchPix;

    if (
      this.state.pixKeyType === "Telefone" &&
      this.props.type === "pixTransfer" &&
      this.props.step === 0
    )
      keySearchPix = "+55" + keySearchPix;

    UtilService.showExternalPixKey({
      account: sessionStorage.getItem("account"),
      key: keySearchPix,
    })
      .then((res) => {
        if (res.data.body.endtoEndId) {
          let currentPayment = that.state.currentPayment;
          currentPayment.endtoEndId = res.data.body.endtoEndId;

          currentPayment.creditParty.key = keySearchPix;
          currentPayment.creditParty.name = res.data.body.owner.name;
          currentPayment.creditParty.accountType =
            res.data.body.account.accountType;
          currentPayment.creditParty.bank = res.data.body.account.participant;

          that.setState({
            currentPayment: currentPayment,
            resSearchExternalKey: res.data.body,
            docSearchPix: res.data.body.owner?.documentNumber || "",
            nameSearchPix: res.data.body.owner?.name || "",
          });
          that.proceed(1);
        }
      })
      .catch((err) => {
        console.error(err);
        if (showAlert) {
          return toast(that.state.translations.accountNotFound, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
            theme: "light",
          });
        }
      });
  }

  updateDescription(description) {
    let currentPayment = this.state.currentPayment;
    currentPayment.remittanceInformation = description;
    this.setState({ currentPayment: currentPayment });
  }

  sendPayment(stepOrType, file = null) {
    this.setState({
      show2FAModal: true,
      transferPending: true,
      pendingStep: stepOrType,
      pendingFile: file,
      twoFactorCode: "",
    });
  }

  confirmTransfer = async (twoFactorCode) => {
    const { pendingStep, pendingFile } = this.state;

    if (pendingStep === "batch" && pendingFile) {
      await CashOutService.sendBatchPayments(pendingFile);
      this.toastMessage(
        "success",
        this.state.translations?.fileSentSuccess ||
          "Arquivo enviado com sucesso!",
      );
      this.setState({ loadingTranfer: false, transferPending: false });
      this.proceed(2);
      return;
    }
    let that = this;
    let currentPayment = that.state.currentPayment;

    currentPayment.debitParty.email = sessionStorage.getItem("emailUser");
    currentPayment.debitParty.account = sessionStorage.getItem("account");
    currentPayment.amount = Number(currentPayment.amount);
    currentPayment.clientCode = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;

    currentPayment.creditParty.taxId = that.state.docSearchPix;
    currentPayment.creditParty.name = that.state.nameSearchPix;
    currentPayment.creditParty.dictType = that.state.pixKeyType;
    if (currentPayment.creditParty.dictType === "Telefone")
      currentPayment.creditParty.dictType = "PHONE";
    else if (currentPayment.creditParty.dictType === "Email")
      currentPayment.creditParty.dictType = "EMAIL";
    else if (currentPayment.creditParty.dictType === "Chave Aleatória")
      currentPayment.creditParty.dictType = "RANDOM";

    currentPayment.creditParty.key = that.state.keySearchPix;
    currentPayment.endtoEndId = that.state.endToEnd;
    currentPayment.conciliationId = that.state.conciliationId;
    currentPayment.twoFactorCode = twoFactorCode || undefined;

    // `emvPayment` é a única fonte de verdade do modo QR. O else é obrigatório:
    // `currentPayment` sobrevive entre tentativas e não pode carregar um
    // qrCodeData de uma tentativa anterior para um pagamento por chave.
    if (that.state.emvPayment) {
      currentPayment.qrCodeData = that.state.emvPayment.qrCodeData;
      currentPayment.initiationType = that.state.emvPayment.initiationType;
    } else {
      delete currentPayment.qrCodeData;
    }

    CashOutService.create(currentPayment)
      .then((res) => {
        const responseBody = res?.data?.body || res?.data || {};
        const responsePaymentData = responseBody?.paymentData || {};
        const responseReceiver =
          responseBody?.receiver ||
          responsePaymentData?.receiver ||
          responsePaymentData?.creditParty ||
          responseBody?.creditParty ||
          {};
        const responseReceiverDocument =
          responseReceiver?.document ||
          responsePaymentData?.receiverDocument ||
          responseBody?.receiverDocument ||
          {};
        const responseAmount = Number(
          responseBody?.amount?.value ?? currentPayment?.amount ?? 0,
        );

        const normalizedResultPayment = {
          id:
            responseBody?.id ||
            responseBody?.externalId ||
            currentPayment?.clientCode ||
            "",
          amount: Number.isNaN(responseAmount) ? 0 : responseAmount,
          endToEndId:
            responseBody?.endToEndId || currentPayment?.endtoEndId || "",
          creditParty: {
            name:
              responseReceiver?.name || currentPayment?.creditParty?.name || "",
            key:
              responsePaymentData?.pixKey ||
              currentPayment?.creditParty?.key ||
              "",
            pixKey:
              responsePaymentData?.pixKey ||
              currentPayment?.creditParty?.key ||
              "",
            bank:
              responseReceiver?.bank ||
              responseReceiver?.participant ||
              currentPayment?.creditParty?.bank ||
              "",
            branch:
              responseReceiver?.branch ||
              responseReceiver?.agency ||
              currentPayment?.creditParty?.branch ||
              "",
            account:
              responseReceiver?.account ||
              responseReceiver?.accountNumber ||
              currentPayment?.creditParty?.account ||
              "",
            taxId:
              responseReceiverDocument?.number ||
              responseReceiver?.taxId ||
              responseReceiver?.documentNumber ||
              currentPayment?.creditParty?.taxId ||
              "",
          },
          debitParty: {
            account:
              currentPayment?.debitParty?.account ||
              sessionStorage.getItem("account") ||
              "",
            email:
              currentPayment?.debitParty?.email ||
              sessionStorage.getItem("emailUser") ||
              "",
            name:
              currentPayment?.debitParty?.name ||
              sessionStorage.getItem("nameUser") ||
              sessionStorage.getItem("userName") ||
              "",
            taxId:
              currentPayment?.debitParty?.taxId ||
              sessionStorage.getItem("doc") ||
              "",
            branch:
              currentPayment?.debitParty?.branch ||
              sessionStorage.getItem("agency") ||
              "",
            bank: currentPayment?.debitParty?.bank || "",
          },
        };

        that.clearCurrentPayment();
        that.setState(
          {
            resultPayment: normalizedResultPayment,
            loadingTranfer: false,
            showConfirmModal: false,
            recipientData: null,
            emvPayment: null,
          },
          () => {
            that.proceed(2);
          },
        );
      })
      .catch((err) => {
        that.setState({ loadingTranfer: false, showConfirmModal: false });
        console.error(err);
        return toast(that.state.translations.errorProcessingPayment, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "error",
          theme: "light",
        });
      });
  };

  updateValueTransfer(
    value,
    docSearchPix,
    nameSearchPix,
    pixKeyType,
    key,
    endToEnd,
    conciliationId,
  ) {
    let that = this;
    let currentPayment = that.state.currentPayment;
    currentPayment.amount = value;
    that.setState({
      currentPayment: currentPayment,
      docSearchPix: docSearchPix,
      nameSearchPix: nameSearchPix,
      pixKeyType: pixKeyType,
      keySearchPix: key,
      endToEnd: endToEnd,
      conciliationId: conciliationId,
    });
  }

  setEmvPayment = (emv) => {
    const currentPayment = this.state.currentPayment;
    currentPayment.amount = emv.amount;

    this.setState({
      currentPayment: currentPayment,
      emvPayment: emv,
      nameSearchPix: emv.receiverName,
      docSearchPix: emv.receiverDocument,
      keySearchPix: "",
    });
  };

  componentDidUpdate(prevProps) {
    // Trocar de aba não pode deixar um qrCodeData pendurado no próximo envio.
    if (prevProps.type !== this.props.type && this.state.emvPayment) {
      this.setState({ emvPayment: null });
    }
  }

  handleChange(value, item) {
    let that = this;
    switch (item) {
      case "recipient":
        that.setState({
          recipientValue: value,
        });
        break;
      case "account":
        that.setState(
          {
            accountSearchPix: value,
          },
          () => {
            that.showExternalKey();
          },
        );
        break;
      case "dayCnpj":
        that.setState({
          valueDayCnpj: value,
        });
        break;
      case "nightPayments":
        that.setState({
          valueNightPayments: value,
        });
        break;
      case "nightCpf":
        that.setState({
          valueNightCpf: value,
        });
        break;
      case "nightCnpj":
        that.setState({
          valueNightCnpj: value,
        });
        break;
      case "dayPayments":
        that.setState({
          valueDayPayments: value,
        });
        break;
      case "dayCpf":
        that.setState({
          valueDayCpf: value,
        });
        break;
      default:
        that.setState({
          value: value,
        });
        break;
    }
  }

  handleKeyTypeChange(e) {
    this.setState({
      pixKeyType: e.target.value,
    });
  }

  applyMask(value, type) {
    switch (type) {
      case "CPF":
        return value
          .replace(/\D/g, "")
          .replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, (full, p1, p2, p3, p4) => {
            return `${p1}${p2 ? `.${p2}` : ""}${p3 ? `.${p3}` : ""}${p4 ? `-${p4}` : ""}`;
          });
      case "CNPJ":
        return value
          .replace(/\D/g, "")
          .replace(
            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
            (full, p1, p2, p3, p4, p5) => {
              return `${p1}${p2 ? `.${p2}` : ""}${p3 ? `.${p3}` : ""}${p4 ? `/${p4}` : ""}${p5 ? `-${p5}` : ""}`;
            },
          );
      case "Telefone":
        return value
          .replace(/\D/g, "")
          .replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3")
          .replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
      default:
        return value;
    }
  }

  removeMask(value) {
    if (
      this.state.pixKeyType !== "Email" &&
      this.state.pixKeyType !== "Chave Aleatória"
    )
      return value.replace(/[.\-()/\s_]/g, "");
    return value;
  }

  searchKeyDict(data, type) {
    let that = this;
    that.setState({ keySearchPix: this.removeMask(data) }, () => {
      if (
        (that.state.pixKeyType === "CPF" &&
          that.state.keySearchPix.length === 11) ||
        (that.state.pixKeyType === "CNPJ" &&
          that.state.keySearchPix.length === 14) ||
        (that.state.pixKeyType === "Telefone" &&
          (that.state.keySearchPix.length === 11 ||
            that.state.keySearchPix.length === 10))
      )
        that.showExternalKey(true);
      else that.showExternalKey();
    });
  }

  handleChangeKeyPix = (e) => {
    const value = e.target.value;

    this.setState({
      keySearchPix: value,
    });

    // this.searchKeyDict(value, "key");
  };

  render() {
    return (
      <section
        id="pixTransferComponent"
        className="pixTransferComponent"
        key={this.props.type}
      >
        {this.props.type === "pixTransfer" &&
          !isMutual() &&
          !isMtBank() &&
          !isVoluti() &&
          this.props.step === 0 && (
            <TransferTypePix
              contacts={this.state.contacts}
              handlePixKeyClick={this.handlePixKeyClick}
              proceed={this.proceed}
              currentPayment={this.state.currentPayment}
              pixKeyType={this.state.pixKeyType}
              creditPartyTaxId={this.state.creditPartyTaxId}
              keySearchPix={this.state.keySearchPix}
              handleChangeKeyPix={this.handleChangeKeyPix}
              handleKeyTypeChange={this.handleKeyTypeChange}
              searchKeyDict={this.searchKeyDict}
            />
          )}
        {this.props.type === "pixTransfer" &&
          (isMutual() || isMtBank() || isVoluti()) &&
          this.props.step === 0 && (
            <TransferTypePixMutual
              handlePixKeyClick={this.handlePixKeyClick}
              proceed={this.proceed}
              currentPayment={this.state.currentPayment}
              pixKeyType={this.state.pixKeyType}
              creditPartyTaxId={this.state.creditPartyTaxId}
              keySearchPix={this.state.keySearchPix}
              handleChangeKeyPix={this.handleChangeKeyPix}
              handleKeyTypeChange={this.handleKeyTypeChange}
              currentBalance={this.state.currentBalance}
              updateValueTransfer={this.updateValueTransfer}
              amount={this.state.currentPayment.amount}
              sendPayment={this.sendPayment}
              loadingTranfer={this.state.loadingTranfer}
            />
          )}
        {this.props.type === "copyAndPaste" &&
          !isMutual() &&
          !isVoluti() &&
          this.props.step === 0 && (
            <TransferTypeCopyPaste
              recipientValue={this.state.recipientValue}
              handleChange={this.handleChange}
              accountSearchPix={this.state.accountSearchPix}
              sendPayment={this.sendPayment}
              loadingTranfer={this.state.loadingTranfer}
              updateValueTransfer={this.updateValueTransfer}
              currentBalance={this.state.currentBalance}
            />
          )}
        {this.props.type === "copyAndPaste" &&
          isMutual() &&
          this.props.step === 0 && (
            <TransferTypeCopyPasteMutual
              currentBalance={this.state.currentBalance}
              sendPayment={this.sendPayment}
              loadingTranfer={this.state.loadingTranfer}
              onEmvPaymentReady={this.setEmvPayment}
            />
          )}
        {this.props.type === "batch" && isMtBank() && this.props.step === 0 && (
          <TransferTypeBatch
            recipientValue={this.state.recipientValue}
            handleChange={this.handleChange}
            accountSearchPix={this.state.accountSearchPix}
            decodeQrCode={this.decodeQrCode}
            sendPayment={this.sendPayment}
            loadingTranfer={this.state.loadingTranfer}
            updateValueTransfer={this.updateValueTransfer}
            currentBalance={this.state.currentBalance}
          />
        )}
        {this.props.type === "qrCode" &&
          !isMutual() &&
          !isVoluti() &&
          this.props.step === 0 && (
            <TransferTypeQRCode
              openQr={this.state.openQr}
              setOpenQr={this.setOpenQr}
              QRScanner={this.QRScanner}
              handleChange={this.handleChange}
              accountSearchPix={this.state.accountSearchPix}
              sendPayment={this.sendPayment}
              loadingTranfer={this.state.loadingTranfer}
              updateValueTransfer={this.updateValueTransfer}
              currentBalance={this.state.currentBalance}
            />
          )}

        {this.props.type === "bankData" &&
          !isMutual() &&
          !isVoluti() &&
          this.props.step === 0 && (
            <TransferTypeBankAccount
              contacts={this.state.contacts}
              handlePixKeyClick={this.handlePixKeyClick}
              proceed={this.proceed}
              currentPayment={this.state.currentPayment}
              pixKeyType={this.state.pixKeyType}
              creditPartyTaxId={this.state.creditPartyTaxId}
              keySearchPix={this.state.keySearchPix}
              handleChangeKeyPix={this.handleChangeKeyPix}
              handleKeyTypeChange={this.handleKeyTypeChange}
              searchKeyDict={this.searchKeyDict}
              sendPayment={this.sendPayment}
              loadingTranfer={this.state.loadingTranfer}
              updateValueTransfer={this.updateValueTransfer}
              currentBalance={this.state.currentBalance}
            />
          )}
        {this.props.type === "pixLimits" &&
          !isMutual() &&
          !isMtBank() &&
          !isVoluti() &&
          this.props.step === 0 && (
            <TransferTypePixLimits
              handleChange={this.handleChange}
              resetPixSettings={this.resetPixSettings}
              savePixLimitSettings={this.savePixLimitSettings}
              valueDayCnpj={this.state.valueDayCnpj}
              valueNightPayments={this.state.valueNightPayments}
              valueNightCpf={this.state.valueNightCpf}
              valueNightCnpj={this.state.valueNightCnpj}
              valueDayPayments={this.state.valueDayPayments}
              valueDayCpf={this.state.valueDayCpf}
            />
          )}
        {this.props.type === "pixKey" &&
          !isMtBank() &&
          this.props.step === 0 && (
            <TransferTypePixKey
              listKeys={this.state.listKeys}
              deleteKey={this.deleteKey}
              handleButtonClick={this.handleButtonClick}
            />
          )}
        {this.props.step === 1 && (
          <TransferOrderResume
            currentPayment={this.state.currentPayment}
            currentBalance={this.state.currentBalance}
            updateValueTransfer={this.updateValueTransfer}
            sendPayment={this.sendPayment}
            loadingTranfer={this.state.loadingTranfer}
            back={this.back}
            updateDescription={this.updateDescription}
            resSearchExternalKey={this.state.resSearchExternalKey}
          />
        )}
        {this.props.step === 2 && (
          <TransferComplete
            type={this.state.pendingStep}
            resultPayment={this.state.resultPayment}
          />
        )}

        <Modal
          show={this.state.isModalOpen}
          onClose={this.handleCloseModal}
          updateKeys={this.updateKeys}
        />
        <ModalKeysInfo
          show={this.state.isModalKeysOpen}
          onClose={this.handleCloseModalKeys}
        />
        <ModalInfo
          show={this.state.isModalInfoOpen}
          onClose={this.handleCloseModalInfo}
        />

        {this.state.showConfirmModal && this.state.recipientData && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                padding: "20px",
                minWidth: "350px",
                maxWidth: "90%",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <h3
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginBottom: "15px",
                }}
              >
                Confirmar transferência
              </h3>

              <div style={{ borderTop: "1px solid #f0f0f0" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "8px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span>
                    <strong>Nome</strong>
                  </span>
                  <span>{this.state.recipientData.name}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "8px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span>
                    <strong>CPF</strong>
                  </span>
                  <span>{this.state.recipientData.taxNumber}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "8px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span>
                    <strong>Banco</strong>
                  </span>
                  <span>{this.state.recipientData.bankData?.name}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "8px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span>
                    <strong>Agência</strong>
                  </span>
                  <span>{this.state.recipientData.bankData?.branch}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "8px 0",
                    borderBottom: "1px solid #f0f0f0",
                  }}
                >
                  <span>
                    <strong>Conta</strong>
                  </span>
                  <span>{this.state.recipientData.bankData?.account}</span>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "20px",
                  gap: "10px",
                }}
              >
                <button
                  onClick={() =>
                    this.setState({
                      showConfirmModal: false,
                      loadingTranfer: false,
                    })
                  }
                  style={{
                    backgroundColor: "white",
                    border: "1px solid #aaa",
                    color: "#555",
                    borderRadius: "6px",
                    padding: "8px 16px",
                    cursor: "pointer",
                  }}
                >
                  Cancelar
                </button>
                <button
                  onClick={this.confirmTransfer}
                  style={{
                    backgroundColor: "white",
                    border: "1px solid #1c787e",
                    color: "#1c787e",
                    borderRadius: "6px",
                    padding: "8px 16px",
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  Confirmar
                </button>
              </div>
            </div>
          </div>
        )}
        {this.state.show2FAModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "8px",
                padding: "24px",
                minWidth: "350px",
                maxWidth: "90%",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
              }}
            >
              <h3
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginBottom: "8px",
                  color: "#333",
                }}
              >
                {this.state.translations.twoFactorAuthentication ||
                  "Autenticação de Dois Fatores"}
              </h3>
              <p
                style={{
                  fontSize: "14px",
                  color: "#666",
                  marginBottom: "20px",
                }}
              >
                {this.state.translations.enterCodeFromApp ||
                  "Digite o código de 6 dígitos do seu aplicativo autenticador:"}
              </p>

              <input
                type="text"
                value={this.state.twoFactorCode}
                onChange={this.handleTwoFactorCodeChange}
                onKeyDown={this.handleEnter2FA}
                maxLength="6"
                placeholder="000000"
                disabled={this.state.loading2FA}
                style={{
                  width: "100%",
                  padding: "12px",
                  fontSize: "18px",
                  textAlign: "center",
                  letterSpacing: "4px",
                  border: "2px solid #ddd",
                  borderRadius: "6px",
                  margin: "16px 0",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />

              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  justifyContent: "flex-end",
                  marginTop: "20px",
                }}
              >
                <button
                  onClick={this.cancel2FA}
                  disabled={this.state.loading2FA}
                  style={{
                    backgroundColor: "white",
                    border: "1px solid #aaa",
                    color: "#555",
                    borderRadius: "6px",
                    padding: "10px 20px",
                    cursor: this.state.loading2FA ? "not-allowed" : "pointer",
                    opacity: this.state.loading2FA ? 0.6 : 1,
                  }}
                >
                  {this.state.translations.cancel || "Cancelar"}
                </button>
                <button
                  onClick={this.verify2FAForTransfer}
                  disabled={
                    this.state.loading2FA ||
                    this.state.twoFactorCode.length !== 6
                  }
                  style={{
                    backgroundColor:
                      this.state.loading2FA ||
                      this.state.twoFactorCode.length !== 6
                        ? "#ccc"
                        : "#1c787e",
                    border: "none",
                    color: "white",
                    borderRadius: "6px",
                    padding: "10px 20px",
                    cursor:
                      this.state.loading2FA ||
                      this.state.twoFactorCode.length !== 6
                        ? "not-allowed"
                        : "pointer",
                    fontWeight: "bold",
                  }}
                >
                  {this.state.loading2FA
                    ? this.state.translations.verifying || "Verificando..."
                    : this.state.translations.verify || "Confirmar"}
                </button>
              </div>
            </div>
          </div>
        )}

        <ToastContainer />
      </section>
    );
  }
}

export default Item;
